import { AlertBanner } from '@apollo/orbit';
import React from 'react';

import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useLDFlag } from 'src/lib/launchDarkly';

export const NewProposalsCheckBehaviourAlert = () => {
  const shouldDescriptionsWarn = useLDFlag(
    'gov-proposal-checks-descriptions-warn',
  );
  const [dismissed, setDismissed] = useLocalStorage(
    'hasDismissedNewProposalsCheckBehaviourAlert',
  );
  return (
    <AlertBanner
      status="info"
      key="info"
      isDismissible
      isOpen={!dismissed && shouldDescriptionsWarn}
      onDismiss={() => setDismissed(true)}
    >
      Proposal checks now WARN instead of FAIL on missing descriptions.
    </AlertBanner>
  );
};
